(function($) {
$(function(){

    if ($('[data-accordion]').length) {
        $('[data-accordion-item-toggle]').on('click', function(){
            var accordion_parent = $(this).parents('[data-accordion]');
            var scroll_on_open = (accordion_parent[0].hasAttribute('data-accordion-scroll-on-open')) ? true : false;

            var this_item = $(this).parents('[data-accordion-item]');
            if (this_item.attr('data-accordion-item') == 'open') {
                // console.log('Closing');
                this_item.attr('data-accordion-item', '');
                this_item.find('[data-accordion-item-content]').slideUp(300);
            } else {
                // console.log('Opening');
                var other_items = $(this).parents('[data-accordion]').find('[data-accordion-item="open"]').not(this_item);
                var other_items_content = other_items.find('[data-accordion-item-content]');
                var this_content = $(this).next('[data-accordion-item-content]');
                this_item.attr('data-accordion-item', 'open');
                other_items.attr('data-accordion-item', '');
                this_content.slideDown(300);
                other_items_content.slideUp(300);

                if (scroll_on_open) {
                    $('html, body').stop(true, false).animate({scrollTop: this_item.offset().top + 1 }, 300);
                }
            }
        });

        $('[data-accordion]').each(function(){
            var accordion_start_val = ~~($(this).attr('data-accordion'));
            if (accordion_start_val > 0 && $(this).find('[data-accordion-item]').length > accordion_start_val) {
                $(this).find('[data-accordion-item]').eq(accordion_start_val - 1).find('[data-accordion-item-toggle]').click();
            }
        });
    }

});
})(jQuery);
